import React from 'react';

const ReactSelectAlias = (props) => {

  return <input
  tabIndex={-1}
  value={props.value || ''}
  required={true}
  onChange={(e) => {e.preventDefault()}}
  style={{
    opacity: 0,
    width: 0,
    height: 0,
    position: 'absolute',
    top: 0,
    cursor: 'default'
  }}
/>;
}

export default ReactSelectAlias;